<!-- Settings Modal -->
<div class="modal fade" [class.show]="isOpen$ | async" [style.display]="(isOpen$ | async) ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="settingsModalLabel" [attr.aria-hidden]="!(isOpen$ | async)">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="settingsModalLabel">User Settings</h5>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <!-- Year Filter Section -->
        <div class="settings-section mb-4">
          <h6 class="section-title mb-2">Year Filter</h6>
          <p class="section-description text-muted small mb-3">
            Select which years of data to display throughout the portal.
            This will filter projects, tasks, and budget data by record creation date.
          </p>

          <div>
            <div *ngIf="loading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div *ngIf="!loading && availableYears.length > 0">

              <!-- Quick Actions -->
              <div class="quick-actions mb-3">
                <button class="btn btn-sm btn-outline-secondary me-2" (click)="selectAllYears()" [disabled]="loading">
                  Select All
                </button>
                <button class="btn btn-sm btn-outline-secondary" (click)="deselectAllYears()" [disabled]="loading">
                  Deselect All
                </button>
              </div>

              <!-- Year Checkboxes -->
              <div class="year-filters">
                <div *ngFor="let yearFilter of availableYears" class="form-check year-checkbox">
                  <input class="form-check-input" type="checkbox" [id]="'year-' + yearFilter.year" [(ngModel)]="yearFilter.enabled" [disabled]="loading">
                  <label class="form-check-label" [for]="'year-' + yearFilter.year">
                    {{ yearFilter.year }}
                  </label>
                </div>
              </div>

              <!-- Warning if no years selected -->
              <div *ngIf="!hasEnabledYears" class="alert alert-warning mt-3" role="alert">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Please select at least one year to display data.
              </div>

              <!-- Save Button -->
              <div class="mt-4">
                <button class="btn btn-primary" (click)="savePreferences()" [disabled]="loading || !hasEnabledYears">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  Save Preferences
                </button>
              </div>

              <!-- Success/Error Messages -->
              <div *ngIf="saveMessage" class="alert alert-success mt-3" role="alert">
                <i class="fas fa-check-circle me-2"></i>
                {{ saveMessage }}
              </div>
              <div *ngIf="saveError" class="alert alert-danger mt-3" role="alert">
                <i class="fas fa-exclamation-circle me-2"></i>
                {{ saveError }}
              </div>
            </div>

            <div *ngIf="!loading && availableYears.length === 0" class="alert alert-info">
              <i class="fas fa-info-circle me-2"></i>
              No year data available yet.
            </div>
          </div>
        </div>

        <!-- Future Settings Sections -->
        <div class="settings-section mt-4">
          <h6 class="section-title mb-2">Additional Settings</h6>
          <p class="section-description text-muted small">
            More customization options coming soon...
          </p>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Modal Backdrop -->
<div class="modal-backdrop fade" [class.show]="isOpen$ | async" *ngIf="isOpen$ | async" (click)="closeModal()"></div>